<template>
  <b-row v-if="error" class="error-row mb-3">
    <b-col>
      <div class="mt-4 d-flex align-items-center justify-content-center">
        <i class="bi bi-exclamation-octagon-fill fs-3 text-danger mx-3"></i>
        <span class="text-danger"> {{ error }}error</span>
      </div>
    </b-col>
  </b-row>
  <div class="mt-5">
    <digital-report-confirm
      v-if="selectedChannel === 'digital-report'"
      :organization-full-name="organizationFullName"
      :email="email"
      :message="message"
      :feature-name="featureName"
    >
    </digital-report-confirm>
    <physical-meeting-confirm
      v-if="selectedChannel === 'physical-meeting'"
      :organization-full-name="organizationFullName"
      :email="email"
      :feature-name="featureName"
    >
    </physical-meeting-confirm>
    <phone-call-confirm
      v-if="selectedChannel === 'phone-call'"
      :organization-full-name="organizationFullName"
      :feature-name="featureName"
    >
    </phone-call-confirm>
  </div>
</template>

<script>
import LocalizableComponent from './LocalizableComponent.vue'
import DigitalReportConfirm from './DigitalReportConfirm.vue'
import PhysicalMeetingConfirm from './PhysicalMeetingConfirm.vue'
import PhoneCallConfirm from './PhoneCallConfirm.vue'

export default {
  name: 'CreateReportConfirm',
  components: {
    DigitalReportConfirm,
    PhysicalMeetingConfirm,
    PhoneCallConfirm
  },
  extends: LocalizableComponent,
  props: {
    message: {
      type: String,
      default: ''
    },
    organizationFullName: {
      type: String,
      default: ''
    },
    email: {
      type: String,
      default: null,
      required: false
    },
    selectedChannel: {
      type: String,
      default: null,
      required: true
    },
    error: {
      type: String,
      default: null,
      required: false
    },
    featureName: {
      type: String,
      default: ''
    }
  },
  data() {
    return {}
  },
  computed: {
    title() {
      return this.organizationFullName
        ? this.ft(this.featureName, 'title', this.$t, {
            organizationTitle: this.organizationFullName
          })
        : this.ft(this.featureName, 'confirm.title.reportNotSent', this.$t)
    }
  }
}
</script>

<style scoped></style>
